const checkPolicy = ({ policies, policy, OrganizationId, ParentId }) => {
    if (policies?.[policy]?.[ParentId]?.[OrganizationId]) {
        return true;
    }

    return false;
};

export default checkPolicy;
